
  <div class="container">
    <div class="row">
        <div class="col-sm-12">
            <app-user-form (customerDetails)="customerDetailShow($event)"></app-user-form>
          </div>
    </div>


    <div class="row">
        <div class="col-sm-12">
            <app-product-form (productDetailShare)="onProudctDetails($event)"></app-product-form>
            <app-user-details [customerValues]="customerValues"></app-user-details>
            <app-product-details [ProductValues]="productDetails"></app-product-details>
            <app-nav-bar></app-nav-bar>
        </div>
    </div>
</div>